import { FormRow, FormSection } from 'framework/ui/layout';
import { Permission } from 'infrastructure/security/authorization/davinciAuthorizationService';
import { UPDATE_EMPLOYEE_ACCOUNTS_1C_ID, UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID } from 'domain/shared/employee';
import AzureIdInput from 'domain/people/employee/shared/input/AzureIdInput';
import { FC } from 'react';
import { TextInput } from 'framework/form';

type AccountsUpdateSectionProps = {
  isGranted: (permission: Permission | Permission[], contextName?: string) => boolean;
};

const AccountsUpdateSection: FC<AccountsUpdateSectionProps> = ({ isGranted }) => {
  return (
    <FormSection
      title="Accounts"
      isVisible={isGranted(UPDATE_EMPLOYEE_ACCOUNTS_1C_ID) || isGranted(UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID)}
    >
      <FormRow>
        <TextInput
          source="extendedInformation.financialInformation.financialOneCId"
          label="1C ID"
          isVisible={isGranted(UPDATE_EMPLOYEE_ACCOUNTS_1C_ID)}
        />
        <AzureIdInput source="azureId" label="Azure ID" isVisible={isGranted(UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID)} />
      </FormRow>
    </FormSection>
  );
};

export { AccountsUpdateSection };
